import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import { getGlobalDealerID, getGlobalDealerName } from './globalState';

function Header() {
  /*
  Renders the app header: logo, hamburger menu, and help button.

  Auth-gated navigation:
    Always visible     → Home, Change Brand, FAQ, Support
    Requires dealer ID → Quick-Start Guide, Photography, Transfer Photos

  getGlobalDealerID() is read fresh on each render so the menu reflects
  the current auth state immediately (Header re-renders on every route
  change).
  */
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const dealerID = getGlobalDealerID();
  const dealerName = getGlobalDealerName();

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  const handleHelpClick = () => {
    navigate('/faq');
    closeMenu();
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => document.body.classList.remove('no-scroll');
  }, [menuOpen]);

  return (
    <header className="App-header">
      {location.pathname !== '/' && (
        <img src="/components/logo.png" alt="Logo" className="small-logo" />
      )}

      <div className={`menu-icon ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      <button className="help-button" onClick={handleHelpClick}>?</button>

      {menuOpen && (
        <div className="menu visible">
          {/* Dealer context banner — shown when logged in */}
          {dealerID && (
            <div className="menu-dealer-badge">
              {dealerName} · {dealerID}
            </div>
          )}

          <ul>
            <li><Link to="/" onClick={closeMenu}>Home</Link></li>
            <li><Link to="/dealer-select" onClick={closeMenu}>Change Brand</Link></li>

            {dealerID ? (
              <>
                <li><Link to="/choose-phototype" onClick={closeMenu}>Choose Phototype</Link></li>
                <li><Link to="/quick-start-guide" onClick={closeMenu}>Quick-Start Guide</Link></li>
                <li><Link to="/photography" onClick={closeMenu}>Photography</Link></li>
                <li><Link to="/photo-gallery" onClick={closeMenu}>Transfer Photos</Link></li>
              </>
            ) : (
              <li className="menu-locked">
                <span title="Enter your Dealer ID to unlock">
                  🔒 Enter Dealer ID to access camera &amp; gallery
                </span>
              </li>
            )}

            <li><Link to="/faq" onClick={closeMenu}>FAQ</Link></li>
            <li><Link to="/support" onClick={closeMenu}>Support</Link></li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default Header;
